import { curry } from 'lib/util'
import find from 'lib/sequence/component/children/find'

/**
 * Focuses the password element. To be used in the module's index action.
 *
 * @type {Gaia.AppModule.EventHandler}
 */
const focusPasswordField = curry((module, component, event) => {
  const actionComponent = module[G.STATE][G.ACTION][G.COMPONENT]
  const { password } = find(actionComponent)

  password[G.STATE].focus = {}
  module[G.ADAPTER][G.UI].update(module)
})

export default focusPasswordField
